import { render, staticRenderFns } from "./ResetPass.vue?vue&type=template&id=378c70c6&"
import script from "./ResetPass.vue?vue&type=script&lang=js&"
export * from "./ResetPass.vue?vue&type=script&lang=js&"
import style0 from "./ResetPass.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports